var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "login",
      on: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.login.apply(null, arguments)
        },
      },
    },
    [
      _c("h2", [
        _vm._v(
          _vm._s(
            _vm.isCheckedEmail
              ? _vm.$t("auth.setPassword")
              : _vm.$t("auth.forgetPasswordEmail")
          )
        ),
      ]),
      _c(
        "form",
        {
          ref: "forgetFrom",
          attrs: {
            name: "login",
            model: _vm.forgetFrom,
            rules: _vm.rules,
            onsubmit: "return false",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isCheckedEmail,
                  expression: "!isCheckedEmail",
                },
              ],
            },
            [
              _c(
                "div",
                {
                  staticClass: "form-group",
                  class: {
                    "has-error": _vm.errors.has("Email"),
                    valid: _vm.isFormFieldValid("Email"),
                  },
                },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.forgetFrom.Email,
                          expression: "forgetFrom.Email",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|email",
                          expression: "'required|email'",
                        },
                      ],
                      attrs: {
                        type: "text",
                        name: "Email",
                        placeholder: _vm.$t("auth.email"),
                        autocomplete: "off",
                        required: "",
                      },
                      domProps: { value: _vm.forgetFrom.Email },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.forgetFrom, "Email", $event.target.value)
                        },
                      },
                    }),
                    _c("i", { staticClass: "bar" }),
                    _c(
                      "small",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("Email"),
                            expression: "errors.has('Email')",
                          },
                        ],
                        staticClass: "help text-danger",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("Email")))]
                    ),
                  ]),
                ]
              ),
              _c("p", { staticClass: "back-login" }, [
                _c("span", { on: { click: _vm.backToLogin } }, [
                  _vm._v(_vm._s(_vm.$t("backToLoginPage"))),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align--center justify--space-between justify-center",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      class: { loading: _vm.isLoading },
                      attrs: {
                        type: "button",
                        id: "login1",
                        disabled: _vm.isLoading,
                      },
                      on: { click: _vm.checkOutEmail },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.isLoading ? "" : _vm.$t("auth.confirm")) +
                          "\n          "
                      ),
                      _vm.isLoading
                        ? _c("Spinner", { attrs: { size: "small" } })
                        : _vm._e(),
                      _vm.isLoading
                        ? _c("span", { staticClass: "spinner-text" }, [
                            _vm._v(_vm._s(_vm.$t("loading"))),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isCheckedEmail,
                  expression: "isCheckedEmail",
                },
              ],
            },
            [
              _c(
                "div",
                {
                  staticClass: "form-group",
                  class: {
                    "has-error": _vm.errors.has("password"),
                    valid: _vm.isFormFieldValid("password"),
                  },
                },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.forgetFrom.password,
                          expression: "forgetFrom.password",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|verifyPassword|validPassword",
                          expression: "'required|verifyPassword|validPassword'",
                        },
                      ],
                      ref: "passwordInput",
                      attrs: {
                        type: "password",
                        name: "password",
                        placeholder: _vm.$t("auth.password"),
                        autocomplete: "new-password",
                        required: "",
                        onkeyup: "value=value.replace(/\\s/g,'')",
                        onkeydown: "value=value.replace(/\\s/g,'')",
                      },
                      domProps: { value: _vm.forgetFrom.password },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.forgetFrom,
                            "password",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _c("i", { staticClass: "bar" }),
                    _c(
                      "small",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("password"),
                            expression: "errors.has('password')",
                          },
                        ],
                        staticClass: "help text-danger",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("password")))]
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "form-group",
                  class: {
                    "has-error": _vm.errors.has("confirmPassword"),
                    valid: _vm.isFormFieldValid("confirmPassword"),
                  },
                },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.forgetFrom.confirmPassword,
                          expression: "forgetFrom.confirmPassword",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|verifyConfirmPassword|validPassword",
                          expression:
                            "'required|verifyConfirmPassword|validPassword'",
                        },
                      ],
                      attrs: {
                        type: "password",
                        name: "confirmPassword",
                        placeholder: _vm.$t("auth.confirmPassword"),
                        autocomplete: "new-password",
                        required: "",
                        onkeyup: "value=value.replace(/\\s/g,'')",
                        onkeydown: "value=value.replace(/\\s/g,'')",
                      },
                      domProps: { value: _vm.forgetFrom.confirmPassword },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.forgetFrom,
                            "confirmPassword",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _c("i", { staticClass: "bar" }),
                    _c(
                      "small",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("confirmPassword"),
                            expression: "errors.has('confirmPassword')",
                          },
                        ],
                        staticClass: "help text-danger",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("confirmPassword")))]
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "form-group",
                  class: {
                    "has-error": _vm.errors.has("verficationCode"),
                    valid: _vm.isFormFieldValid("verficationCode"),
                  },
                },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.forgetFrom.verficationCode,
                          expression: "forgetFrom.verficationCode",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        name: "verficationCode",
                        placeholder: _vm.$t("auth.verficationCode"),
                        autocomplete: "off",
                        required: "",
                      },
                      domProps: { value: _vm.forgetFrom.verficationCode },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.forgetFrom,
                            "verficationCode",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _c("i", { staticClass: "bar" }),
                    _c(
                      "small",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("verficationCode"),
                            expression: "errors.has('verficationCode')",
                          },
                        ],
                        staticClass: "help text-danger",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("verficationCode")))]
                    ),
                  ]),
                ]
              ),
              _c("p", { staticClass: "verification-time" }, [
                _vm._v(
                  "The verification code is valid for " +
                    _vm._s(_vm.remainingTime) +
                    " minutes"
                ),
              ]),
              _c("p", { staticClass: "back-login" }, [
                _c("span", { on: { click: _vm.backToLogin } }, [
                  _vm._v(_vm._s(_vm.$t("backToLoginPage"))),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align--center justify--space-between justify-center",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      class: { loading: _vm.isLoading },
                      attrs: {
                        type: "button",
                        id: "login2",
                        disabled: _vm.isLoading,
                      },
                      on: { click: _vm.resetPassword },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.isLoading ? "" : _vm.$t("auth.confirm")) +
                          "\n          "
                      ),
                      _vm.isLoading
                        ? _c("Spinner", { attrs: { size: "small" } })
                        : _vm._e(),
                      _vm.isLoading
                        ? _c("span", { staticClass: "spinner-text" }, [
                            _vm._v(_vm._s(_vm.$t("loading"))),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }